import '@css/main.scss'
import '@js/bootstrap'

import {Header} from '@js/components/Header'
import {Slider} from '@js/components/Slider'
import {Archive} from '@js/components/Archive'
import {ProductGallery} from '@js/components/ProductGallery'
import {CartManager} from '@js/components/CartPreact'
import {TomSelectComponent} from '@js/components/TomSelect'
import {ModalRequest} from '@js/components/ModalRequest'

window.onload = () => {
  new Header()
  new Archive()
  new Slider()
  new ProductGallery()
  new TomSelectComponent()
  new ModalRequest()

  // Initialiser le système de panier Preact
  window.cart = new CartManager()

  document.addEventListener('forminator:form:submit:success', function(event) {
    var form_id = event.target.find('input[name="form_id"]').val();
    if (form_id != 89) {
      return;
    }

    // remove local storage cart
    localStorage.removeItem('cart');
  });
}
